import { render, staticRenderFns } from "./MonetaryType.vue?vue&type=template&id=fbc159a0&"
import script from "./MonetaryType.vue?vue&type=script&lang=js&"
export * from "./MonetaryType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports